import React from "react";
import Paper from "@material-ui/core/Paper";
// import "../../admin/routes/setup/programme/table.css";
import { CircularProgress } from "@material-ui/core";
import { connect } from "react-redux";
import { fetchJSON } from "helpers/axios";
import applicant from "../../applicant/routes/dashboard/index";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { OSCOHTLogo, Ondo } from "assets/images/image";
import "../../components/ApplicantForm/ApplicantForm.print.css";


// This function is used to display the appliant form for usermode of applicant
class ApplicantForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      olevel: [],
      loadingOlevel: false,
        passportBase64: null,
    };
  }

  componentDidMount() {
    const { applicant } = this.props;
    // if (applicant?.AdmModeId === 1) {
    //   this.applicantOlevel();
    // }
    this.updatePrintHeaderFooter();
     this.loadPassport();
  }
  handleDobValue = (DateOfBirth) => {
    const myDate = new Date(DateOfBirth);
    const dayOfMonth = myDate.getDate();
    const month = myDate.getMonth();
    const year = myDate.getFullYear();
    if (myDate !== "") {
      return year + "-" + this.pad(month + 1) + "-" + this.pad(dayOfMonth);
    }
  };
  pad = (n) => {
    return n < 10 ? "0" + n : n;
  };

  // Convert image to base64 for better download compatibility
  convertToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/jpeg", 0.8));
      };
      img.onerror = () => reject(url);
      img.src = url;
    });
  };

loadPassport = async () => {
  const { applicant } = this.props;
  const url = applicant?.Passport || 
    "https://unicrossdoc.blob.core.windows.net/passport/Avatar.jpg";

  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({ passportBase64: reader.result });
    };
    reader.readAsDataURL(blob);
  } catch (err) {
    console.warn("Passport load failed", err);
  }
};

  updatePrintHeaderFooter = () => {
    const { applicant } = this.props;
    const now = new Date().toLocaleString();

    const header = document.getElementById("print-header");
    const footer = document.getElementById("print-footer");

    if (header) {
      header.style.display = "block";
      header.style.textAlign = "center";
      header.style.marginBottom = "20px";
      header.style.borderBottom = "1px solid black";
      header.innerHTML = `
      <h3>Ondo State College of Health Technology, Akure</h3>
      <p>Printed on: ${now}</p>
      <p>Applicant: ${applicant?.LastName || ""} ${applicant?.FirstName ||
        ""}</p>
    `;
    }

    if (footer) {
      footer.style.display = "block";
      footer.style.textAlign = "center";
      footer.style.marginTop = "30px";
      footer.style.borderTop = "1px solid black";
      footer.innerHTML = `
      <p>This document is system-generated and valid for admission purposes.</p>
    `;
    }
  };

render() {
  const { applicant, loading } = this.props;

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>
        <CircularProgress />
        <p>Loading applicant details...</p>
      </div>
    );
  }

  return (
    <>
      {/* ✅ Use CSS class — print media query targets this */}
      <Paper className="applicant-form-wrapper">
        <div id="content"   style={{
      width: "794px",
      margin: "0 auto",   // ✅ centers it on screen
    }}>
          <div className="applicant-form-inner">

            {/* Watermark */}
            <div
              className="applicant-watermark"
              style={{ backgroundImage: `url(${OSCOHTLogo})` }}
            />

            <div className="applicant-outer-border">

              {/* Header */}
              <div className="applicant-header-row">
                <img src={Ondo} alt="Logo" className="applicant-logo" style={{height: "100px", width: "100px"}} />

                <div className="applicant-header-center">
                  <h2>COLLEGE OF HEALTH TECHNOLOGY</h2>
                  <p>Ondo State College of Health Technology, Akure</p>
                  <div className="applicant-session-bar">
                    {applicant?.Session} Academic Session
                  </div>
                </div>

                <img src={OSCOHTLogo} alt="Logo" className="applicant-logo" />
              </div>

              {/* Main Info Table */}
              <table className="applicant-table">
                <tbody>

                  {/* Personal info header + passport */}
                  <tr>
                    <td colSpan={4} className="section-header">
                      CANDIDATE PERSONAL INFORMATION
                    </td>
                    <td  className="applicant-passport-cell">
                      <img
                        src={
                          this.state.passportBase64 ||applicant?.Passport 
                        }
                        alt="Passport"
                        className="applicant-passport-img"
                      />
                    </td>
                  </tr>

                  {[
                    ["Admission Number",            applicant?.ApplicantNumber],
                    ["Name of Candidate",           `${applicant?.LastName || ""} ${applicant?.FirstName || ""} ${applicant?.OtherName || ""}`],
                    ["Date of Birth",               this.handleDobValue(applicant?.DateOfBirth)],
                    ["Gender",                      applicant?.Gender],
                    ["Contact Address",             applicant?.Address],
                    ["Contact GSM Number",          applicant?.PhoneNumber],
                    ["State of Origin",             applicant?.StateName],
                    ["Local Government of Origin",  applicant?.LGAName],
                  ].map(([label, value], i) => (
                    <tr key={i}>
                      <td colSpan={4}>{label}</td>
                      <td colSpan={2} className="field-value">{value}</td>
                    </tr>
                  ))}

                  {/* Result Card */}
                  {/* <tr>
                    <td colSpan={6} className="subsection-header">Result Card Detail</td>
                  </tr>
                  <tr>
                    <td colSpan={4}>Result Serial Number</td>
                    <td colSpan={2} className="field-value">{applicant?.ResultSerialNumber}</td>
                  </tr>
                  <tr>
                    <td colSpan={4}>Result PIN Number</td>
                    <td colSpan={2} className="field-value">{applicant?.ResultPIN}</td>
                  </tr> */}

                  {/* Course */}
                  <tr>
                    <td colSpan={6} className="course-section-header">
                      CANDIDATE CHOICE OF DEPARTMENT &amp; COURSE
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={4}>Department</td>
                    <td colSpan={2} className="field-value">{applicant?.DepartmentName}</td>
                  </tr>
                  <tr>
                    <td colSpan={4}>Course</td>
                    <td colSpan={2} className="field-value">{applicant?.DepartmentName}</td>
                  </tr>

                </tbody>
              </table>

              {/* Notice */}
              <div className="applicant-notice">
                You are requested to print and bring this slip to the Examination Hall
              </div>

              {/* Footer */}
              <div className="applicant-footer-row">
                <span>Registration</span>
                <span>{new Date().toLocaleTimeString()}</span>
              </div>

            </div>
          </div>
        </div>
      </Paper>
    </>
  );
}
}
const mapStateToProps = ({ settings, auth }) => {
  const authUser = auth.applicantUser;
  const { userMode } = auth;
  return { authUser, userMode };
};

export default connect(mapStateToProps, { applicant })(ApplicantForm);
